var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTremors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 359"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 770685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6667 34.3798L18.0736 33.7201C17.2504 32.8045 16.6044 31.7502 16.167 30.6087L14.9883 27.5328C14.6965 26.7712 14.9428 25.9125 15.5972 25.4103C16.5788 24.6571 18.0236 25.012 18.5243 26.1293L19.5197 28.3506C20.2657 28.546 21.976 29.3067 22.8497 30.786M19.5204 28.3533L22.0188 19.238C22.2948 18.2312 23.3534 17.6336 24.3834 17.9034C25.4133 18.1732 26.0245 19.2081 25.7485 20.215L24.0475 25.4103L26.3482 18.0273C26.6241 17.0204 27.6828 16.4229 28.7127 16.6927C29.7427 16.9625 30.3539 17.9974 30.0779 19.0043L27.6187 26.5598L29.0785 22.6504C29.3545 21.6436 30.4131 21.0461 31.4431 21.3158C32.473 21.5856 33.0842 22.6205 32.8083 23.6274L29.878 34.3181C29.6426 35.1771 29.0677 35.9093 28.28 36.3541L27.6187 36.7273M21.0501 14H17.6204L18.4778 18.191L13.3333 19.8675M34.9035 14.8382L34.0461 17.3528L38.3333 18.191L36.6184 24.0585",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTremors);
export default __webpack_public_path__ + "static/media/tremors.0e6889d24054827ef23dd63cfac8978b.svg";
export { ForwardRef as ReactComponent };